import React, { useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { useTranslation } from 'react-i18next';
import { faReply, faShare } from '@fortawesome/free-solid-svg-icons';
import TabHeader from '@/components/TabHeader/TabHeader';

import styles from './CostSimulator.module.scss';
import BgImg from './montecon_img_simulador.png';
import {
  CostSimulatorImport,
  CostSimulatorImportFormState,
} from './CostSimulatorImport';
import {
  CostSimulatorExport,
  CostSimulatorFormState,
} from './CostSimulatorExport';
import { CostSimulatorResults } from './CostSimulatorResults';

enum Tabs {
  FclImport = 0,
  FclExport = 1,
}

const CostSimulator: React.FC = () => {
  const { t } = useTranslation('costSimulatorForm');
  const [activeIndex, setActiveIndex] = useState(0);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [isExportSliderOpen, setIsExportSliderOpen] = useState(false);

  const [importData, setImportData] = useState<{
    results: string | null | undefined;
    formDataImport: CostSimulatorImportFormState;
    total: number;
  }>();
  const [exportData, setExportData] = useState<{
    results: string | null | undefined;
    formDataExport: CostSimulatorFormState;
    total: number;
  }>();

  return (
    <div className={styles.container}>
      <header>
        <h1>{t('costSimulator')}</h1>
      </header>
      <div className={styles.whiteBg}>
        <TabView
          className={styles.tabView}
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        >
          <TabPanel
            className={styles.tabPanelHeader}
            header={
              <TabHeader
                active={activeIndex === Tabs.FclImport}
                label={t('fclImport')}
                icon={faReply}
                className={styles.headerTemplateText}
              />
            }
          >
            <CostSimulatorImport
              setIsSliderOpen={setIsSliderOpen}
              setImportData={(newResults, newFormData, total) =>
                setImportData({
                  results: newResults,
                  formDataImport: newFormData,
                  total,
                })
              }
            />
            <div className={styles.imgContainer}>
              <CostSimulatorResults
                data={importData}
                isSliderOpen={isSliderOpen}
                isImport
              />
              <img
                src={BgImg}
                alt="Description"
                className={styles.imgInstructions}
              />
            </div>
          </TabPanel>
          <TabPanel
            className={styles.tabPanelHeader}
            header={
              <TabHeader
                active={activeIndex === Tabs.FclExport}
                label={t('fclExport')}
                icon={faShare}
                className={styles.headerTemplateText}
              />
            }
          >
            <CostSimulatorExport
              setExportData={(newResults, newFormData, total) =>
                setExportData({
                  results: newResults,
                  formDataExport: newFormData,
                  total,
                })
              }
              setIsExportSliderOpen={setIsExportSliderOpen}
            />
            <div className={styles.imgContainer}>
              <CostSimulatorResults
                data={exportData}
                isSliderOpen={isExportSliderOpen}
              />
              <img
                src={BgImg}
                alt="Description"
                className={styles.imgInstructions}
              />
            </div>
          </TabPanel>
        </TabView>
      </div>
    </div>
  );
};

export default CostSimulator;
